import React, { lazy } from "react";
import { mainRoutes } from "./mainRoutes";
import { authRoutes } from "@/features/auth/routes/authRoutes";
import { interviewRoutes } from "@/features/interview/routes/interviewRoutes";
import RouterErrorBoundary from "../errors/RouterErrorBoundary/RouterErrorBoundary";

const NotFound = lazy(() => import("../errors/NotFound/NotFound"));

export const routerConfig = [
  ...mainRoutes,
  ...authRoutes,
  ...interviewRoutes,
  
  {
    path: "*",
    element: <NotFound />,
    errorElement: <RouterErrorBoundary />,
  },
];
